export default "__VITE_ASSET__BLO5pDHi__"